import { Button } from "~/components";
import { Link } from "@remix-run/react";
import { IcoAppStore, IcoGoogleStore } from "~/icons";

import mainPreviews from "/img/main-preview.png";

const Home = () => {
  return (
    <section
      className="max-md:pt-[90px] min-h-screen bg-[url('/img/main-bg.png')] bg-no-repeat bg-cover max-md:bg-[53%_50%] bg-center pt-[124px]"
      id="home"
    >
      <div className="container max-md:h-auto h-[calc(100vh-124px)]">
        <div className="grid max-md:grid-cols-1 grid-cols-2 h-[inherit] items-center">
          <div>
            <h1 className="max-lg:text-[40px] max-lg:leading-[55px] text-center text-white text-[64px] font-extrabold uppercase leading-[80px]">
              Get Ready For Endless Romance
            </h1>
            <p className="max-lg:mt-4 max-lg:mb-6 max-lg:text-xl max-lg:leading-7 text-center text-white text-2xl font-light tracking-tight my-9">
              Your #1 Romance Audiobook App <br />
              with Unlimited Listening
            </p>
            <div className="flex justify-center max-md:mb-6">
              <Button className="max-md:w-full max-md:px-0 px-24" />
            </div>
          </div>
          <div>
            <img
              className="mx-auto max-w-[424px] max-md:max-w-full"
              src={mainPreviews}
              alt="Application Preview"
            />
            <div className="mt-8 flex justify-center gap-4">
              <Link to="https://tempt.onelink.me/kExy/zpj3ql1p" target="_blank">
                <IcoAppStore width={90} height={30} />
              </Link>
              <Link to="https://tempt.onelink.me/m74p/ujnu7xo6" target="_blank">
                <IcoGoogleStore width={90} height={30} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Home.disolayName = "Home";
export default Home;
